import { Box, Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useSegments } from "@/company/data/useSegments";
import { deserializeFilterParam, SegmentUrl } from "@reflag/shared/urls";

export default function CompaniesToSegmentsRedirect() {
  const [searchParams] = useSearchParams();
  const filter =
    (searchParams.get("filter")
      ? deserializeFilterParam(searchParams.get("filter") ?? "")
      : undefined) ?? undefined;
  const navigate = useNavigate();
  const { data: segments, isSuccess } = useSegments();

  const { env } = useEnvironment();
  const segmentId = searchParams.get("segment");
  const view = searchParams.get("view") as "companies" | "users" | null;

  useEffect(() => {
    if (isSuccess && segments) {
      // Determine target segment: if segmentId is provided and found, use it; otherwise use "all" segment
      const targetSegment =
        (segmentId && segments.find((s) => s.id === segmentId)) ||
        segments.find((s) => s.isAllSegment);

      if (targetSegment) {
        const path = SegmentUrl(env, targetSegment, {
          view: "companies",
          filter,
        });
        navigate(path, { replace: true });
        return;
      }
    }
  }, [isSuccess, segments, segmentId, view, navigate, env, filter]);

  // Show loading spinner while redirecting
  return (
    <Box alignItems="center" display="flex" h="100vh" justifyContent="center">
      <Spinner size="lg" />
    </Box>
  );
}
